import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Mail, Phone, MapPin, Calendar, Award, BookOpen, Users } from "lucide-react";
const Resume = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800 rtl">
      <div className="container mx-auto px-6 py-12">
        {/* כפתור חזרה */}
        <div className="mb-8">
          <Button onClick={() => navigate('/')} className="bg-white/20 hover:bg-white/30 text-white border border-white/30">
            <ArrowRight className="w-4 h-4 ml-2" />
            חזרה לדף הבית
          </Button>
        </div>

        {/* כותרת */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-white mb-4">קורות חיים</h1>
          <h2 className="text-3xl font-light text-blue-100">רסיטל יצחקי</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-400 to-teal-400 mx-auto mt-4 rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* עמודה ימנית - פרטים אישיים */}
          <div className="lg:col-span-1 space-y-6">
            <Card className="bg-white/10 backdrop-blur-md border border-white/20 text-white">
              <CardHeader>
                <CardTitle className="text-right text-xl">פרטים אישיים</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="text-right">
                  <p>רסיטל יצחקי</p>
                </div>
                <div className="text-right">
                  <p>מקצועית בפיתוח תכנים</p>
                </div>
                <div className="text-right">
                  <p>מעל 20 שנות ניסיון</p>
                </div>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-md border border-white/20 text-white">
              <CardHeader>
                <CardTitle className="text-right text-xl">התמחויות</CardTitle>
              </CardHeader>
              <CardContent className="text-right space-y-2">
                <p>• מנהיגות חינוכית</p>
                <p>• פיתוח חוסן רגשי</p>
                <p>• כתיבה נרטיבית</p>
                <p>• ליווי תהליכי שינוי</p>
                <p>• פיתוח תכניות בשילוב יישומי AI</p>
              </CardContent>
            </Card>
          </div>

          {/* עמודה שמאלית - ניסיון מקצועי */}
          <div className="lg:col-span-2 space-y-6">
            <Card className="bg-white/10 backdrop-blur-md border border-white/20 text-white">
              <CardHeader>
                <CardTitle className="text-right text-2xl">ניסיון מקצועי</CardTitle>
              </CardHeader>
              <CardContent className="text-right space-y-6">
                <div>
                  <h3 className="text-xl font-semibold text-blue-200 mb-2">2022–2025: מתאמת של"צ נוער, "אדיוסיסטמס", נתניה</h3>
                  <ul className="space-y-1 text-white/90">
                    <li>• ליווי נערים עוברי חוק בתהליך שיקום אישי וחברתי באמצעות התנדבות בקהילה</li>
                    <li>• שותפות עם גורמי רווחה, קהילה ועמותות ליצירת תכניות מותאמות</li>
                    <li>• בניית קשרי אמון עם בני נוער בסיכון ושיתוף פעולה עם הצוותים המקצועיים המלווים אותם</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-blue-200 mb-2">2019–2021: מרצה וחונכת בתכנית להכשרת מנהלים, סמינר הקיבוצים, תל אביב-יפו</h3>
                  <ul className="space-y-1 text-white/90">
                    <li>• ליווי והנחיית מנהלים בראשית דרכם, כולל התמודדות עם אוכלוסיות מגוונות ובמצבי סיכון</li>
                    <li>• פיתוח הרצאות והדרכות בתחומי ניהול, הכלה ויצירת אקלים מיטבי בבתי ספר</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-blue-200 mb-2">2012–2018: מנהלת בית ספר "תל נורדאו", תל אביב-יפו</h3>
                  <ul className="space-y-1 text-white/90">
                    <li>• ניהול צוות של 42 אנשים ומעל ל-400 תלמידים</li>
                    <li>• הובלת תהליכים חינוכיים ערכיים שזיכו את בית הספר כבית ספר מוביל בתחומי ההכלה והסובלנות ובתחומים נוספים</li>
                    <li>• פיתוח השתלמויות להטמעת כלים רגשיים-חברתיים בהוראה</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-blue-200 mb-2">2008–2011: סגנית מנהלת, בית ספר "היובל", תל אביב-יפו</h3>
                  <ul className="space-y-1 text-white/90">
                    <li>• ניהול פדגוגי וארגוני לצד מנהלת בית הספר</li>
                    <li>• ליווי והנחיית צוותי הוראה בפיתוח תכניות עבודה מותאמות לתלמידים</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-blue-200 mb-2">1998–2008: מחנכת, בית ספר "היובל", תל אביב-יפו</h3>
                  <ul className="space-y-1 text-white/90">
                    <li>• חינוך והוראת כיתות יסוד</li>
                    <li>• פיתוח ויישום כלים חינוכיים לשילוב תלמידים בעלי קשיים לימודיים, רגשיים וחברתיים בכיתות</li>
                  </ul>
                </div>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-md border border-white/20 text-white">
              <CardHeader>
                <CardTitle className="text-right text-2xl">השכלה והכשרות</CardTitle>
              </CardHeader>
              <CardContent className="text-right space-y-4">
                <div>
                  <p className="text-white/90">תואר ראשון בחינוך</p>
                </div>
                <div>
                  <p className="text-white/90">תואר שני במנהל החינוך (בהצטיינות)</p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>;
};
export default Resume;